import React from "react";
import CountAnalysisCard from "./CountAnalysisCard";
import { useSelector } from "react-redux";
import { getMyOrganization, getScreeningStats } from "@src/redux";
import { MdDashboard } from "react-icons/md";
import { Tooltip } from "antd";

const ScreeningCountAnalysis: React.FC = () => {
  const { result: rootOrganizationDetails } = useSelector(getMyOrganization);
  const { result: screeningStats } = useSelector(getScreeningStats);

  const subjectLabel =
    rootOrganizationDetails?.rootOrganization?.subjectLabel || "";

  const pct =
    screeningStats?.totalSubjectCount && screeningStats?.screenedSubjectCount
      ? Number(
          (Number(screeningStats.screenedSubjectCount) /
            Number(screeningStats.totalSubjectCount)) *
            100
        ).toFixed(2)
      : undefined;

  return (
    <section className="home-section">
      <div className="home-section-header">
        <span className="home-section-accent" />
        <h2 className="home-section-title">Screening Count Analysis</h2>
        <Tooltip title="Open on-board analysis" getPopupContainer={() => document.body}>
          <a href="/on-board-analysis" className="home-section-action">
            <MdDashboard size={18} />
          </a>
        </Tooltip>
      </div>

      <div className="stat-card-row">
        <CountAnalysisCard
          variant="total"
          totalWorkers={screeningStats?.totalSubjectCount ?? 0}
          cardTitle={`Total ${subjectLabel}`}
        />
        <CountAnalysisCard
          variant="screened"
          totalWorkers={screeningStats?.screenedSubjectCount ?? 0}
          cardTitle={`Medical Screened ${subjectLabel}`}
          percentage={pct}
        />
      </div>
    </section>
  );
};

export default ScreeningCountAnalysis;
